var models = [
		   {
			name: "Hair Color",
			type: "GC",
			category: "trait",
			genes: [{ snp: "eum", risk: "B", RAF: 0.41 },{ snp: "pheo", risk: "R", RAF:0.32}],
			outcomes: [
					{ mut: [[2,'*']], 	desc: "" },
					{ mut: [[1,'*']], 	desc: "" },
					{ mut: [[0, 2]], 	desc: "" },
					{ mut: [[0, 1]], 	desc: "" },
					{ mut: [[0, 0]], 	desc: "" }],
			images: ['','','','',''],
		}
	];
	
	
	function QuickCalc() {
	
	    this.GetResultsQuick = function (model, f, m, ff, fm, mf, mm) {
	        var out;
	        switch (model.type) {
	            case 'GC':
					//alert(model+"||"+f+"||"+ m+"||"+ff+"||"+fm+"||"+mf+"||"+mm)
	                out = this.quick_GC(model, f, m, ff, fm, mf, mm);
	                break;
	            default:
	                alert('' + model.type);
	        }
	        // adjusting probabilities
	        var s = 0;
	        for (var j = 0; j < out.length; j++)
	            s += out[j].prob;
	        if (isNaN(s)) {
	            return false;
	        }
	        else if (s != 0 && s != 1)
	            for (var j = 0; j < out.length; j++)
	                out[j].prob /= s;
	        return out;
	    }
	    //==================================================
	    Array.prototype.add = function (v2) {
	        var out = new Array(this.length);
	        for (var i = 0; i < this.length; i++)
	            out[i] = this[i] + v2[i];
	        return out;
	    }
	    Array.prototype.norm = function () {
	        var sum = 0;
	        var out = new Array(this.length);
	        for (var i = 0; i < this.length; i++)
	            sum += this[i];
	        for (var i = 0; i < this.length; i++)
	            out[i] = this[i] / sum;
	        return out;
	    }
	
	    calc_GC_prob = function (Prob, mut) {
	        var prb = 1;
	        for (var ii = 0; ii < mut.length; ii++) {
	            switch (mut[ii]) {
	                case '+': prb *= (Prob[ii][1] + Prob[ii][2]); break;
	                case '*': break;
	                default: prb *= Prob[ii][mut[ii]]; break;
	            }
	        }
	        return prb;
	
	    }
	
	    pheno_to_prob = function (outcome, genes) {
	        var out = Array(genes.length);
	        for (var j = 0; j < genes.length; j++) {
	            var RAF = genes[j].RAF;
	            out[j] = [0, 0, 0];
	            if (isNaN(outcome) == false)
	                out[j] = [(1 - RAF) * (1 - RAF), 2 * (1 - RAF) * (RAF), RAF * RAF];
	            else {
	                for (var i = 0; i < outcome.mut.length; i++) {
	                    switch (outcome.mut[i][j]) {
	                        case 0: out[j] = out[j].add([(1 - RAF) * (1 - RAF), 0, 0]); break;
	                        case 1: out[j] = out[j].add([0, 2 * (1 - RAF) * (RAF), 0]); break;
	                        case 2: out[j] = out[j].add([0, 0, RAF * RAF]); break;
	                        case '*': out[j] = out[j].add([(1 - RAF) * (1 - RAF), 2 * (1 - RAF) * (RAF), RAF * RAF]); break;
	                        case '+': out[j] = out[j].add([0, 2 * (1 - RAF) * (RAF), RAF * RAF]); break;
	                    }
	                }
	            }
	        }
	        for (var i = 0; i < genes.length; i++)
	            out[i] = out[i].norm();
	        return out;
	    }
	
	    quick_permutate = function (f, m) {
	        var n = f.length;
	        var Prob = Array(n);
	        for (var i = 0; i < n; i++) {
	            // matrix (m*[]*f') multiplication - expanded
	            Prob[i] = [0, 0, 0];
	            Prob[i][0] = f[i][0] * m[i][0] + 0.5 * f[i][0] * m[i][1] + 0.5 * f[i][1] * m[i][0] + 0.25 * f[i][1] * m[i][1];
	            Prob[i][1] = 0.5 * f[i][0] * m[i][1] + f[i][0] * m[i][2] + 0.5 * f[i][1] * m[i][0] + 0.5 * f[i][1] * m[i][1] + 0.5 * f[i][1] * m[i][2] + f[i][2] * m[i][0] +
						0.5 * f[i][2] * m[i][1];
	            Prob[i][2] = 0.25 * f[i][1] * m[i][1] + 0.5 * f[i][1] * m[i][2] + 0.5 * f[i][2] * m[i][1] + f[i][2] * m[i][2];
	            Prob[i] = Prob[i].norm();
	        }
	        return Prob;
	    }
	
	    this.quick_GC = function (model, ph_f, ph_m, ph_ff, ph_fm, ph_mf, ph_mm) {
	        var f = pheno_to_prob(ph_f == -1 ? 0 : model.outcomes[ph_f], model.genes);
	        var m = pheno_to_prob(ph_m == -1 ? 0 : model.outcomes[ph_m], model.genes);
	        // father's parents
	        if (ph_ff != -1 || ph_fm != -1) {
	            var ff = pheno_to_prob(ph_ff == -1 ? 0 : model.outcomes[ph_ff], model.genes);
	            var fm = pheno_to_prob(ph_fm == -1 ? 0 : model.outcomes[ph_fm], model.genes);
	            var prob = quick_permutate(ff, fm);
	            for (var i = 0; i < prob.length; i++) {
	                f[i][0] = f[i][0] ? prob[i][0] : 0;
	                f[i][1] = f[i][1] ? prob[i][1] : 0;
	                f[i][2] = f[i][2] ? prob[i][2] : 0;
	                f[i] = f[i].norm();
	            }
	        }
	        // mother's parents
	        if (ph_mf != -1 || ph_mm != -1) {
	            var mf = pheno_to_prob(ph_mf == -1 ? 0 : model.outcomes[ph_mf], model.genes);
	            var mm = pheno_to_prob(ph_mm == -1 ? 0 : model.outcomes[ph_mm], model.genes);
	            var prob = quick_permutate(mf, mm);
	            for (var i = 0; i < prob.length; i++) {
	                m[i][0] = m[i][0] ? prob[i][0] : 0;
	                m[i][1] = m[i][1] ? prob[i][1] : 0;
	                m[i][2] = m[i][2] ? prob[i][2] : 0;
	                m[i] = m[i].norm();
	            }
	        }
	
	        var Prob = quick_permutate(f, m);
	
	        var out = Array(model.outcomes.length);
	        for (var i = 0; i < model.outcomes.length; i++) {
	            out[i] = { prob: 0, out: i, desc: model.outcomes[i].desc };
	            for (var j = 0; j < model.outcomes[i].mut.length; j++) {
	                out[i].prob += calc_GC_prob(Prob, model.outcomes[i].mut[j]);
	            }
	        }
	        if (model.postprocess)
	            out = model.postprocess(out);
	        return out;
	    }
	}

(function($) {
    "use strict"; // Start of use strict
        
    $('#formHair').trigger("reset");
    
	var $colors;
	
	function sendForm () {
        
        var $colorToCode = {
	        'UNDEFINED' : '-1',
	        'BLACK' : '0',
	        'BROWN' : '1',
	        'RED' : '2',
	        'STBLOND' : '3',
	        'BLOND' : '4'
        };
        
        var $f = $colorToCode[$('select[name="FA"] option:selected').val()];
        var $m = $colorToCode[$('select[name="MO"] option:selected').val()];
        var $ff = $colorToCode[$('select[name="PGF"] option:selected').val()];
        var $fm = $colorToCode[$('select[name="PGM"] option:selected').val()];
        var $mf = $colorToCode[$('select[name="MGF"] option:selected').val()];
        var $mm = $colorToCode[$('select[name="MGM"] option:selected').val()];
                
        var Calc = new QuickCalc;

		var id = 0;
		
		var model = models[id];
		
		var result=Calc.GetResultsQuick(model, $f, $m, $ff, $fm, $mf, $mm);
		
		console.log(result);
		
		return result;
	}
	
	$('.hair_selector').each(function(index) {
		
		var $i=0;
		// Lors du clique sur un des .hair_selector
		$(this).click(function(e) {
			var $colors=['UNDEFINED', 'BLACK', 'BROWN', 'RED', 'STBLOND', 'BLOND'];
			// On affiche le loader
			$('#ajax-loading').show();
			
			$i++;
			if ($i>=6) {$i=0;}
			
			// Dans le cas ou un seul des grand-parrent a les cheveux BLACK, il est imposible que leur enfant ait les cheveux RED ou STBLOND ou BLOND
			if ($('span.PGM').hasClass('BLACK') || $('span.PGF').hasClass('BLACK')) {
				if ($(this).hasClass('FA')) {
					delete $colors[$colors.indexOf('RED')];
					delete $colors[$colors.indexOf('STBLOND')];
					delete $colors[$colors.indexOf('BLOND')];
				}
			}
			if ($('span.MGM').hasClass('BLACK') || $('span.MGF').hasClass('BLACK')) {
				if ($(this).hasClass('MO')) {
					delete $colors[$colors.indexOf('RED')];
					delete $colors[$colors.indexOf('STBLOND')];
					delete $colors[$colors.indexOf('BLOND')];
				}
			}
			// Dans le cas ou un seul des grand-parrent a les cheveux RED, il est imposible que leur enfant ait les cheveux BLACK ou BLOND
			if ($('span.PGM').hasClass('RED') || $('span.PGF').hasClass('RED')) {
				if ($(this).hasClass('FA')) {
					delete $colors[$colors.indexOf('BLACK')];
					delete $colors[$colors.indexOf('BLOND')];
				}
			}
			if ($('span.MGM').hasClass('RED') || $('span.MGF').hasClass('RED')) {
				if ($(this).hasClass('MO')) {
					delete $colors[$colors.indexOf('BLACK')];
					delete $colors[$colors.indexOf('BLOND')];
				}
			}
			// Dans le cas ou un seul des grand-parrent a les cheveux STBLOND, il est imposible que leur enfant ait les cheveux BLACK
			if ($('span.PGM').hasClass('STBLOND') || $('span.PGF').hasClass('STBLOND')) {
				if ($(this).hasClass('FA')) {
					delete $colors[$colors.indexOf('BLACK')];
				}
			}
			if ($('span.MGM').hasClass('STBLOND') || $('span.MGF').hasClass('STBLOND')) {
				if ($(this).hasClass('MO')) {
					delete $colors[$colors.indexOf('BLACK')];
				}
			}
			// Dans le cas ou un seul des grand-parrent a les cheveux BLOND, il est imposible que leur enfant ait les cheveux BLACK
			if ($('span.PGM').hasClass('BLOND') || $('span.PGF').hasClass('BLOND')) {
				if ($(this).hasClass('FA')) {
					delete $colors[$colors.indexOf('BLACK')];
					delete $colors[$colors.indexOf('RED')];
				}
			}
			if ($('span.MGM').hasClass('BLOND') || $('span.MGF').hasClass('BLOND')) {
				if ($(this).hasClass('MO')) {
					delete $colors[$colors.indexOf('BLACK')];
					delete $colors[$colors.indexOf('RED')];
				}
			}

			
			$colors = $colors.filter(function(e){return e}); 
			
			if ($colors.length<=5) {
				$colors=$colors.concat($colors);
				if ($colors.length<=5) {
					$colors=$colors.concat($colors);
					if ($colors.length<=5) {
						$colors=$colors.concat($colors);
					}
				}
			}
			
			if ($colors.length>=7) {
				$colors.splice(6,50);
			}
			
			
			// On supprime toutes les classes de couleur afin d'ajouter uniquement la nouvelle couleur			
			$(this).removeClass('UNDEFINED BLACK BROWN RED STBLOND BLOND');
			$(this).addClass($colors[$i]);
			// On modifie le select du formulaire
			$(this).siblings('select').val($colors[$i]);
			// On modifie le nom de la couleur affiché
			var $hair_color=$(this).siblings('select').children(':selected').text();
			$(this).siblings('span').children('span').html($hair_color);
			
			
			// Dans le cas ou les deux grands parents ont les cheveux roux il est imposible que leur enfant aient les cheveux d'une autre couleur
			// On modifie automatiquement la couleur des enfants en bleu
			if (($('span.PGM').hasClass('RED')) && ($('span.PGF').hasClass('RED'))) {
				$('span.FA').removeClass('UNDEFINED BLACK BROWN STBLOND BLOND');
				$('span.FA').addClass('RED');
				$('span.FA').siblings('select').val('RED');
				var $hair_color1=$('span.FA').siblings('select').children(':selected').text();
				$('span.FA').siblings('span').children('span').html($hair_color1);
			}
			
			if (($('span.MGM').hasClass('RED')) && ($('span.MGF').hasClass('RED'))) {
				$('span.MO').removeClass('UNDEFINED BLACK BROWN STBLOND BLOND');
				$('span.MO').addClass('RED');
				$('span.MO').siblings('select').val('RED');
				var $hair_color2=$('span.MO').siblings('select').children(':selected').text();
				$('span.MO').siblings('span').children('span').html($hair_color2);
			}
			
			// Dans le cas ou les deux grands parents ont les cheveux noir il est imposible que leur enfant aient les cheveux d'une autre couleur
			// On modifie automatiquement la couleur des enfants en bleu
			if (($('span.PGM').hasClass('BLACK')) && ($('span.PGF').hasClass('BLACK'))) {
				$('span.FA').removeClass('UNDEFINED BROWN RED STBLOND BLOND');
				$('span.FA').addClass('BLACK');
				$('span.FA').siblings('select').val('BLACK');
				var $hair_color3=$('span.FA').siblings('select').children(':selected').text();
				$('span.FA').siblings('span').children('span').html($hair_color3);
			}
			
			if (($('span.MGM').hasClass('BLACK')) && ($('span.MGF').hasClass('BLACK'))) {
				$('span.MO').removeClass('UNDEFINED BROWN RED STBLOND BLOND');
				$('span.MO').addClass('BLACK');
				$('span.MO').siblings('select').val('BLACK');
				var $hair_color4=$('span.MO').siblings('select').children(':selected').text();
				$('span.MO').siblings('span').children('span').html($hair_color4);
			}
			
			// Dans le cas ou les deux grands parents ont les cheveux BLOND il est imposible que leur enfant aient les cheveux d'une autre couleur
			// On modifie automatiquement la couleur des enfants en bleu
			if (($('span.PGM').hasClass('BLOND')) && ($('span.PGF').hasClass('BLOND'))) {
				$('span.FA').removeClass('UNDEFINED BLACK BROWN RED STBLOND');
				$('span.FA').addClass('BLOND');
				$('span.FA').siblings('select').val('BLOND');
				var $hair_color5=$('span.FA').siblings('select').children(':selected').text();
				$('span.FA').siblings('span').children('span').html($hair_color5);
			}
			
			if (($('span.MGM').hasClass('BLOND')) && ($('span.MGF').hasClass('BLOND'))) {
				$('span.MO').removeClass('UNDEFINED BLACK BROWN RED STBLOND');
				$('span.MO').addClass('BLOND');
				$('span.MO').siblings('select').val('BLACK');
				var $hair_color6=$('span.MO').siblings('select').children(':selected').text();
				$('span.MO').siblings('span').children('span').html($hair_color6);
			}
			
			var result = sendForm();
			
			if (result==false) {
				if ($(this).hasClass('PGM') || $(this).hasClass('PGF')) {
					$('span.FA').removeClass('BLACK BROWN RED STBLOND BLOND');
					$('span.FA').addClass('UNDEFINED');
					$('span.FA').siblings('select').val('UNDEFINED');
					var $hair_color7=$('span.FA').siblings('select').children(':selected').text();
					$('span.FA').siblings('span').children('span').html($hair_color7);
				}
				if ($(this).hasClass('MGM') || $(this).hasClass('MGF')) {
					$('span.MO').removeClass('BLACK BROWN RED STBLOND BLOND');
					$('span.MO').addClass('UNDEFINED');
					$('span.MO').siblings('select').val('UNDEFINED');
					var $hair_color8=$('span.MO').siblings('select').children(':selected').text();
					$('span.MO').siblings('span').children('span').html($hair_color8);
				}
				var result = sendForm();
			}
			
			$('#BLACK').html(Math.round(result[0].prob*100)+'%');
			$('#BROWN').html(Math.round(result[1].prob*100)+'%');
	        $('#RED').html(Math.round(result[2].prob*100)+'%');
	        $('#STBLOND').html(Math.round(result[3].prob*100)+'%');
	        $('#BLOND').html(Math.round(result[4].prob*100)+'%');


		});
	});
	
	var result=sendForm();
			
	$('#BLACK').html(Math.round(result[0].prob*100)+'%');
	$('#BROWN').html(Math.round(result[1].prob*100)+'%');
    $('#RED').html(Math.round(result[2].prob*100)+'%');
    $('#STBLOND').html(Math.round(result[3].prob*100)+'%');
    $('#BLOND').html(Math.round(result[4].prob*100)+'%');
	
	$('a.share').click(function(e){
		e.preventDefault();
		var $link   = $(this);
		var href    = $link.attr('href');
		var network = $link.attr('data-network');
		var networks = {
			facebook : { width : 600, height : 300 },
			twitter  : { width : 600, height : 254 },
			google   : { width : 515, height : 490 },
			linkedin : { width : 600, height : 473 }
		};
		var popup = function(network){
			var options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,';
			window.open(href, '', options+'height='+networks[network].height+',width='+networks[network].width);
		}
		popup(network);
	});
})(jQuery); // End of use strict